// src/Components/Auth/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../config';
import './Login.css';

const Login = ({ onLogin }) => {
    const [formData, setFormData] = useState({ user: '', pass: '' });
    const [loading, setLoading]   = useState(false);
    const [message, setMessage]   = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const res = await fetch(api('/login.php'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include', // importante per la sessione PHP
            });

            const text = await res.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch {
                throw new Error('Risposta non valida dal server');
            }

            if (data.success) {
                const user = data.user || {};

                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('username', user.username || formData.user);
                if (user.id) localStorage.setItem('userId', String(user.id));

                onLogin?.(true);
                navigate('/dashboard', { replace: true });
            } else {
                setMessage(data.result || 'Username o password non validi');
            }
        } catch (err) {
            console.error('Login error:', err);
            setMessage('Errore di connessione: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Accedi</h1>
                    <p>Inserisci le tue credenziali per continuare</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="user">Username</label>
                        <input
                            id="user"
                            name="user"
                            type="text"
                            value={formData.user}
                            onChange={handleChange}
                            placeholder="Inserisci il tuo username"
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="pass">Password</label>
                        <input
                            id="pass"
                            name="pass"
                            type="password"
                            value={formData.pass}
                            onChange={handleChange}
                            placeholder="Inserisci la tua password"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Accesso in corso…' : 'Accedi'}
                    </button>

                    {message && (
                        <div className={`message ${message.toLowerCase().includes('successo') ? 'success' : 'error'}`}>
                            {message}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default Login;
